import React from 'react';
import { withCookies } from 'react-cookie';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fab from '@material-ui/core/Fab';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import MobilePupilPage from './MobilePupilPage';
import MobileNonLoggedPage from './MobileNonLoggedPage';
import MobileDashboardPage from './logged/MobileDashboardPage';
import PupilSelector from './parts/PupilSelector';
import MenuDialog from './parts/MenuDialog';
import store from '../store/index';
import { fetchPupils, setData } from '../actions/index';
import { appColours } from '../helpers';
import ErrorBoundary from './parts/Error/ErrorBoundary';

const colours = appColours();
const styles = () => ({
  appBar: {
    color: '#000',
    backgroundColor: '#fff',
  },
  appBarHeading: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  appBarSubHeading: {
    fontSize: 12,
  },
  menuIconButton: {
    position: 'absolute',
    right: 0,
    marginRight: 24,
  },
  loadingWrapper: {
    padding: 24,
    textAlign: 'center',
  },
  pageWrapper: {
    padding: 24,
  },
  appHeaders1: {
    '& header': {
      backgroundColor: colours[0][0],
      color: '#fff',
    },
  },
  appHeaders2: {
    '& header': {
      backgroundColor: colours[1][0],
      color: '#fff',
    },
  },
  appHeaders3: {
    '& header': {
      backgroundColor: colours[2][0],
      color: '#fff',
    },
  },
  fab: {
    position: 'fixed',
    bottom: 16,
    right: 16,
    backgroundColor: '#f56a12',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
});

// TODO: include the image locally
const logoUrl = 'https://195ec04504ea0272771e-7c2c6dacbab7a2b2d574b53c70c1fe31.ssl.cf3.rackcdn.com/6.1.31/img/logo/CC_logo.png';

class MobileApp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFabPupilSelectorOpen: false,
      menuIsOpen: false,
      menuHash: '',
    };

    this.onMenuClick = this.onMenuClick.bind(this);
    this.onFabButtonClick = this.onFabButtonClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.onPupilClick = this.onPupilClick.bind(this);
    this.onPupilAdded = this.onPupilAdded.bind(this);
    this.onMenuItemClick = this.onMenuItemClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeydown, false);
  }

  onKeydown(event) {
    if (
      event.keyCode === 27 && // escape key
      this.state.isFabPupilSelectorOpen
    ) {
      this.setState({
        isFabPupilSelectorOpen: false,
      });
    }
  }

  onClickAway() {
    if (this.state.isFabPupilSelectorOpen) {
      this.setState({
        isFabPupilSelectorOpen: false,
      });
    }
  }

  onMenuClick() {
    this.setState({
      menuIsOpen: true,
      menuHash: new Date().getTime().toString(), // Hack for the redrawing
    });
  }

  onPupilClick(pupil) {
    store.dispatch(setData(pupil, 'selectedPupil'));
    this.setState({
      isFabPupilSelectorOpen: false,
    });
  }

  onPupilAdded() {
    this.setState({
      isFabPupilSelectorOpen: false,
    });

    store.dispatch(fetchPupils());
  }

  onMenuItemClick(key) {
    this.setState({
      menuIsOpen: false,
      menuHash: new Date().getTime().toString(), // Hack for the redrawing
    });

    if (key === 'dashboard') {
      window.location.hash = '';

      if (this.props.onDashboardClick) {
        this.props.onDashboardClick();
      }
    } else if (key === 'logout') {
      this.props.onLogoutClick();
    } else if (key === 'my_code') {
      this.props.onMyCodeClick();
    }
  }

  onFabButtonClick() {
    this.setState({
      isFabPupilSelectorOpen: true,
    });
  }

  render() {
    const {
      isFabPupilSelectorOpen,
      menuIsOpen,
      menuHash,
    } = this.state;
    const {
      classes,
      selectedPupil,
      selectedPupilIndex,
      isLoggedIn,
      view,
    } = this.props;

    const headerBackgroundIndex = selectedPupil === null
      ? 0
      : (selectedPupilIndex % colours.length) + 1;

    return (
      <ErrorBoundary location="MobileApp.js">
      <div id="mobile-app" className={classes[`appHeaders${headerBackgroundIndex}`]}>
        <AppBar
          position="static"
          className={classes.appBar}
        >
          <Toolbar>
            {selectedPupil && (
              <div>
                <div className={classes.appBarHeading}>
                  {selectedPupil.first_name}
                </div>
                <div className={classes.appBarSubHeading}>
                  {selectedPupil.last_name}
                </div>
              </div>
            )}
            {!selectedPupil && (
              <img src={logoUrl} alt="Logo" />
            )}
            {isLoggedIn && (
              <IconButton
                color="inherit"
                aria-label="Menu"
                className={`menu-button ${classes.menuIconButton}`}
                onClick={this.onMenuClick}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
        {view === 'loading' && (
          <div className={classes.loadingWrapper}>
            <CircularProgress />
          </div>
        )}
        {view === 'dashboard' && (
          <div className={classes.pageWrapper}>
            <MobileDashboardPage useSuspense={false} />
          </div>
        )}
        {view === 'pupil' && (
          <div>
            <MobilePupilPage useSuspense={false} />
          </div>
        )}
        {view === 'non_logged' && (
          <div>
            <MobileNonLoggedPage useSuspense={false} />
          </div>
        )}
        <MenuDialog
          isOpen={menuIsOpen}
          hash={menuHash}
          onMenuItemClick={this.onMenuItemClick}
          useSuspense={false}
        />
        {isLoggedIn && appType === 'parent' && (
          <div>
            <Fab
              className={`fab-button ${classes.fab}`}
              onClick={this.onFabButtonClick}
            >
              <AccountCircle />
            </Fab>
            {isFabPupilSelectorOpen && (
              <PupilSelector
                onClickAway={this.onClickAway}
                onPupilClick={this.onPupilClick}
                onPupilAdded={this.onPupilAdded}
              />
            )}
          </div>
        )}
      </div>
      </ErrorBoundary>
    );
  }
}

export default withStyles(styles)(withCookies(MobileApp));
